import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-ncs-alert',
  templateUrl: './ncs-alert.component.html',
  styleUrls: ['./ncs-alert.component.css']
})
export class NcsAlertComponent implements OnInit {



  @Input() message: string = ''; // The message to display
  @Input() autoHideTime: number = 10000; // Time to auto-hide in milliseconds (default 5 seconds)
  @Input() type: string = 'info'; // Type of alert (info, danger, success, etc.)

  showAlert: boolean = true;
  alertClass: string = ''; // Holds the dynamic class for the alert type

  ngOnInit(): void {
    // Set the alert class based on the type
    this.setAlertClass();

    // Auto-hide after the specified time
    if (this.autoHideTime) {
      setTimeout(() => {
        this.closeAlert();
      }, this.autoHideTime);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['message'] && this.message != '') {
      this.showAlert = true;
      if (this.autoHideTime) {
        setTimeout(() => {
          this.closeAlert();
        }, this.autoHideTime);
      }
    }
  }

  // Dynamically set the CSS class based on the alert type
  setAlertClass() {
    switch (this.type) {
      case 'danger':
        this.alertClass = 'alert alert-danger';
        break;
      case 'success':
        this.alertClass = 'alert alert-success';
        break;
      case 'warning':
        this.alertClass = 'alert alert-warning';
        break;
      default:
        this.alertClass = 'alert alert-info'; // Default to info
        break;
    }
  }

  // Close the alert manually
  closeAlert() {
    this.showAlert = false;
  }
}
